import apiClient from '@/config/api';

export interface AlertTotals {
  checkins: number;
  devices: number;
  ips: number;
}

export interface AlertDailyRow {
  day: string;
  checkins: number;
  devices: number;
  ips: number;
}

export interface AlertHourlyRow {
  hour: number;
  checkins: number;
  devices: number;
}

export interface AlertVersionRow {
  version: string;
  checkins: number;
  devices: number;
  ips: number;
  last_seen: string;
}

export interface AlertStats {
  days: number;
  totals: AlertTotals;
  allTime: AlertTotals;
  daily: AlertDailyRow[];
  hourly: AlertHourlyRow[];
  byVersion: AlertVersionRow[];
}

export interface AlertCheckinRow {
  id: string;
  appVersion: string | null;
  buildNumber: string | null;
  deviceId: string | null;
  ipAddress: string | null;
  createdAt: string;
}

export interface AlertHolidayRow {
  id: string;
  /** 'YYYY-MM-DD' (KST) */
  date: string;
  name: string;
  createdAt: string;
}

export const alertApi = {
  stats: async (days = 30): Promise<AlertStats> => {
    const res = await apiClient.get('/admin/alert/stats', { params: { days } });
    return res.data.data;
  },
  checkins: async (limit = 50): Promise<AlertCheckinRow[]> => {
    const res = await apiClient.get('/admin/alert/checkins', { params: { limit } });
    return res.data.data;
  },
  holidays: async (year?: number): Promise<AlertHolidayRow[]> => {
    const res = await apiClient.get('/admin/alert/holidays', { params: year ? { year } : {} });
    return res.data.data;
  },
  addHoliday: async (date: string, name: string): Promise<AlertHolidayRow> => {
    const res = await apiClient.post('/admin/alert/holidays', { date, name });
    return res.data.data;
  },
  deleteHoliday: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/alert/holidays/${id}`);
  },
};
